import { types } from "../types/types";
import { fetchConToken } from "../helpers/fetch";
import { startSpinner, finishSpinner } from "./ui/spinner";
import { startAlerta } from "./ui/alertas";
import { evaluarDocumentacionAfiliado } from "./documentaciones/documentacion";
import { prepareBeneficiarios } from "../helpers/prepareBeneficiarios";
import { registroUser } from "./movimientosUser/movimientosUser";
import publicIp from "public-ip";
import { enviarCredencialesAfiliado } from "./webAfiliado/afiliadoVariosAction";
import { fetchGrupoFamiliar } from "./grupoFamiliar";
import { handleErrorApi } from "../helpers/randoms";
import { OBRAS_SOCIALES } from "../utils/constants";

export const seleccionAfiliado = (afiliado, idConsulta) => {
  return (dispatch) => {
    dispatch(seleccionar(afiliado, idConsulta));
  };
};
const seleccionar = (afiliado, idConsulta) => ({
  type: types.afiliacionesAfiliadoSeleccionado,
  payload: { afiliado: afiliado, idConsulta: idConsulta },
});
const reloadPlanConvenio = (plan) => ({
  type: types.afiliacionesAfiliadoReloadPlanConvenio,
  payload: plan,
});

export const actualizarDatosPersonales = (datos) => {
  return {
    type: types.afiliacionesActualizarDatosPersonales,
    payload: datos,
  }
};

export const desSeleccionarAfiliado = () => ({
  type: types.afiliacionesAfiliadoLimpiarSeleccion,
});

export const desSeleccionarAfiliadoConsulta = () => ({
  type: types.afiliacionesAfiliadoConsultaLimpiarSeleccion
})

export const traerAfiliadoXId = (id) => {
  return async (dispatch) => {
    try {
      const response = await fetchConToken(`Afiliados/traerPorIdAfiliado/${id}`);
      if (response.ok) {
        const contentType = response.headers.get("content-type");
        if (contentType && contentType.indexOf("application/json") !== -1) {
          const afiliado = await response.json();
          dispatch(seleccionar(afiliado));
        } else {
          throw new Error(response);
        }
      }
    } catch (error) {
      console.log('error en update afiliado', error);
    }
  };
}

export const traerTitularPorCUIL = (cuil) => {
  return async (dispatch) => {
    try {
      const response = await fetchConToken(`Afiliados/traerTitularPorCUIL/${cuil}`);
      if (response.ok) {
        const contentType = response.headers.get("content-type");
        if (contentType && contentType.indexOf("application/json") !== -1) {
          const titular = await response.json();
          dispatch(seleccionar(titular));
        } else {
          throw new Error(response);
        }
      }
    } catch (error) {
      console.log('error en traer titular por cuil', error);
    }
  };
}

export const afiliadoStartUpdate = (afiliado, route = "", esReactivacion = false) => {
  return async (dispatch, getState) => {
    try {
      dispatch(startSpinner());
      const auth = getState().auth;
      const afiliadoPrevUpdate = getState().afiliacion.afiliado
      //const direccionIP = getDirectionIp();
      const afiliadoPreparado = await prepareBeneficiarios(afiliado);
      const response = await fetchConToken(`Afiliados/${afiliado.id_afiliado}/${afiliado.idGrupoFamiliar}/${esReactivacion}`, afiliadoPreparado, 'PUT');
      const respuesta = await response.json();
      if (response.status !== 200) throw respuesta.errores;
      if (response.ok) {
        const contentType = response.headers.get("content-type");
        if (contentType && contentType.indexOf("application/json") !== -1) {

          dispatch(startAlerta(`${afiliado.apellido_y_nombre} Actualizado correctamente`, 'success', 'Comando Exitoso'));
          afiliado.externo = false;
          dispatch(afiliadoUpdated(afiliado));
          dispatch(evaluarDocumentacionAfiliado());
          let dataP = { usuario: auth.userName, direccionIP: await publicIp.v4(), nombreAfiliado: afiliado.apellido_y_nombre, cuil: afiliado.cuil };
          dispatch(registroUser(dataP));
          dispatch(fetchGrupoFamiliar(afiliado.id_afiliado));

          //Esto es para cuando se actuliza el perfil del usuario desde soporte
          if (route === "/soporte-afiliados/contacto") {
            if (afiliado.domiciliosAfiliados.mail !== afiliadoPrevUpdate.domiciliosAfiliados.mail) {
              dispatch(enviarCredencialesAfiliado(afiliado.id_afiliado))
            }
          }
          //dispatch(seleccionar(afiliado));
          //dispatch(traerAfiliadoXId(afiliado.id_afiliado));
        } else {
          throw response.errores;
        }
      }
      dispatch(finishSpinner());
    } catch (err) {
      dispatch(finishSpinner());
      dispatch(startAlerta(err.mensaje, "warning", `¡Error!`));
    }
  };
};
const afiliadoUpdated = (afiliado) => ({
  type: types.afiliacionesAfiliadoUpdated,
  payload: afiliado,
});



export const getObrasSociales = () => {
  return async (dispatch) => {
    try {
      dispatch(startSpinner());
      const result = await fetchConToken(`ObrasSociales`);
      const body = await result.json();
      if (result.ok) {
        dispatch({
          type: types.afiliacionesSetObrasSocialesSuccess,
          payload: body,
        });
      } else {
        throw body;
      }
      dispatch(finishSpinner());
    } catch (error) {
      dispatch(finishSpinner());
      dispatch({ type: types.afiliacionesSetObrasSocialesError });
      handleErrorApi(
        dispatch,
        error,
        "Error al obtener la lista de obras sociales",
        "Ha ocurrido un error. Intente nuevamente"
      );
    }
  };
};

export const buscarAfiliadoSegunObraSocial = (idObraSocial, texto, setOptions, active, obrasSociales) => {
  return async (dispatch) => {
    try {

      const obraSocial = obrasSociales.find(os => os.idObraSocial === idObraSocial);

      if (obraSocial.tienePadron) {
        const response = await fetchConToken(
          `AfiliadosExternos/buscarAfiliadoExternoEnPadron/${idObraSocial}/${texto}`
        );
        const contentType = response.headers.get("content-type");
        if (contentType && contentType.indexOf("application/json") !== -1) {

          const lista = await response.json();

          if (active && lista.length > 0) {
            setOptions(
              Object.keys(lista).map((id_afiliado) => lista[id_afiliado])
            );
          }
          if (lista.errores && lista.errores !== "" && texto.length === 8) {
            dispatch(startAlerta("Afiliado inexistente o dado de baja.", "error"))
          }
        }
      } else {
        if (idObraSocial === OBRAS_SOCIALES.OSOCNA) {
          const response = await fetchConToken(
            `AfiliadosExternos/validarAfiliadoExterno/${idObraSocial}/${texto}`
          );
          const contentType = response.headers.get("content-type");
          if (contentType && contentType.indexOf("application/json") !== -1) {

            const lista = await response.json();

            if (active && lista.length > 0) {
              setOptions(
                Object.keys(lista).map((id_afiliado) => lista[id_afiliado])
              );
            }
            if (lista.errores && lista.errores !== "" && texto.length === 8) {
              dispatch(startAlerta("Afiliado inexistente o dado de baja.", "error"))
            }
          }
        } else {
          dispatch(startAlerta("No hay procedimiento definido para esta Obra Social", "error"));
        }
      }
    } catch (error) {
      handleErrorApi(
        dispatch,
        error,
        "Error al obtener afiliado",
        "Ha ocurrido un error. Intente nuevamente"
      );
    }
  };
};

export const traerPlanYConvenio = (id) => {
  return async (dispatch) => {
    try {
      const response = await fetchConToken(`Afiliados/traerPlanConvenioIdAfiliado/${id}`);
      if (response.ok) {
        const contentType = response.headers.get("content-type");
        if (contentType && contentType.indexOf("application/json") !== -1) {
          const planConvenio = await response.json();
          dispatch(reloadPlanConvenio(planConvenio));
        } else {
          throw new Error(response);
        }
      }
    } catch (error) {
      console.log('error en update afiliado', error);
    }
  };
}
